<template>
  <Toast/>
  <div class="row">
    <div class="col titre">
      <h2>Groupe de Sécurité</h2>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-4 lbl">
          <label>Nom :</label>
        </div>
        <div class="col-4">
          <InputText v-model="groupesSecurite.nom"/>
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl">
          <label>Confidentialité :</label>
        </div>
        <div class="col-4">
          <Dropdown v-model="groupesSecurite.confidentialite" :options="confidentialiteLibelles" optionValue="valeur"
                    optionLabel="texte"
                    scrollHeight="205px" :showClear="true"/>
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl">
          <label>Autorité :</label>
        </div>
        <div class="col-4">
          <Dropdown v-model="groupesSecurite.autorite" :options="niveauHierarchiqueLibelles" optionValue="valeur"
                    optionLabel="texte"
                    scrollHeight="205px" :showClear="true"/>
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl">
          <label>Abréviation :</label>
        </div>
        <div class="col-4">
          <InputText v-model="groupesSecurite.abreviation"/>
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl">
          <label>Description :</label>
        </div>
        <div class="col-4">
          <InputText v-model="groupesSecurite.description"/>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div v-if="isSauvegardeEnCours" class="col">
      <vue-loaders name="ball-beat"></vue-loaders>
    </div>
    <div v-else class="col">
      <Button @click="sauvegarder"> Sauvegarder </Button>
    </div>
    <div class="col">
      <Button @click="fermer"> Fermer </Button>
    </div>
  </div>
</template>

<script>

import axios from "axios";
import {mapGetters} from "vuex";

export default {
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Ajouter un groupe de sécurité");
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store.dispatch('dossier/rechercherDefaut48HeuresAction')
        .then((res) => {
          this.confidentialiteLibelles = res.data.entiteDecision.confidentialite.libelles;
          this.niveauHierarchiqueLibelles = res.data.entiteDecision.authorite.libelles;
        });
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  data() {
    return {
      groupesSecurite: {},
      isSauvegardeEnCours: false,
      confidentialiteLibelles: null,
      niveauHierarchiqueLibelles: null
    }
  },
  methods: {
    sauvegarder(){
      this.isSauvegardeEnCours = true;
      this.$store.dispatch('pilotage/ajouterGroupesSecuriteAction', {groupeSecurite: this.groupesSecurite}).then(() => {
        this.isSauvegardeEnCours = false;
        this.$toast.add({
          severity:'success',
          summary: 'Ajout GroupesSecurite',
          detail:"L'ajout a été effectué",
          life: 6000
        });
      });
    },
    fermer(){
        this.$root.$refs.breadcrumbComp.rediriger();
    }
  }
}
</script>
